// extracted by mini-css-extract-plugin
export default {"container":"OddaniaDetails_container__03dse","stage":"OddaniaDetails_stage__jIOK6","btn_zamknij":"OddaniaDetails_btn_zamknij__nOHmM","stageBtn":"OddaniaDetails_stageBtn__T-DMB"};